// extracted by mini-css-extract-plugin
export default {"header":"Settings_header__n6acH","account_warning":"Settings_account_warning__7hpJb","section_header":"Settings_section_header__JOzrl","eyeIcon":"Settings_eyeIcon__+3-OV"};